import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ElementWithTooltip } from 'DesignSystem/Tooltips';
import { ProductContent } from 'DesignSystem/Typography';

const ElementWithAnswerFilledTooltip = ({ targetElement }) => {
  const tooltipContentClasses = classNames(
    'recipient-preview-tour-tooltip-content',
    'recipient-preview-answer-filled-tooltip-text',
  );
  return (
    <ElementWithTooltip
      className="recipient-preview-tour-tooltip self-serve-recipient-preview-answer-filled-tooltip"
      displayEvent="none"
      placement="left"
      showByDefault
      size="lg"
      targetClassName="self-serve-recipient-preview-answer-filled-tooltip-target"
      targetElement={targetElement}
      tooltipId="selfServeRecipientPreviewAnswerFilledTooltip"
    >
      <ProductContent
        className={tooltipContentClasses}
        variation="small"
      >
        Your answer has automatically plugged into your document. Click below to exit.
      </ProductContent>
    </ElementWithTooltip>
  );
};

ElementWithAnswerFilledTooltip.propTypes = {
  targetElement: PropTypes.node.isRequired,
};

export default ElementWithAnswerFilledTooltip;



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/components/ElementWithAnswerFilledTooltip.jsx